import getHumanDuration from '@/utils/time/getHumanDurationRounded';

export const getRemainingDuration = (duration: number, progress: number) =>
  getHumanDuration((duration * (100 - progress)) / 100);
